import React from "react";

import Addposter from "../../assets/images/Home/Choosesec/app.png";
import { Col, Row, Button } from "react-bootstrap";
const Choosekansensus = () => {
  const features = [
    {
      title: "AI-Powered Profiles",
      description:
        "Create rich, contextual profiles for every important person in your life or work.",
      id: 1,
    },
    {
      title: "Smart Notes & Linked Context",
      description:
        "Connect notes, documents, preferences, decisions, and milestones to the right relationship.",
      id: 2,
    },
    {
      title: "Conversation Insights",
      description: "Capture or import calls, meetings, notes, transcripts, or audio files, then let AI extract key takeaways.",
      id: 3,
    },
    {
      title: "Calendar & Reminders",
      description:
        "Sync important dates, upcoming events, anniversaries, meetings, and follow-ups.",
      id: 4,
    },
    {
      title: "AI Follow-Up Workflows",
      description:
        "Turn conversations into next steps, check-ins, scheduled reminders, and progress tracking.",
      id: 5,
    },
    {
      title: "Privacy-First Controls",
      description:
        "Choose storage preferences, manage access, export data, and stay in control of sensitive relationship information.",
      id: 6,
    },
  ];
  return (
    <>
      <div id="feature" style={{height:"80px"}}></div>
      <div className="choose-kansensus-component container">
        <Row>
          <Col className="feature-details mt-5" xs={12} md={12} lg={6}>
            <div className="content mt-1">
              {/* <h5>Features</h5> */}
              <h1>
               Key <span>Features</span>
              </h1>
              <div className="feature-list mt-5">
                {features.map((feature, index) => (
                  <div key={feature.id} className="feature-item mb-3">
                    <input
                      type="radio"
                      id={`feature${index}`}
                      disabled
                      checked={index % 2 === 0}
                    />
                    <label htmlFor={`feature${index}`}>
                      <h3>{feature.title}</h3>
                      <p className="mb-2">{feature.description}</p>
                    </label>
                  </div>
                ))}
              </div>
              <div className="mt-4 ms-4">
                <Button 
                  className="btn-theme-default px-4 py-3 fw-bold" 
                  style={{ fontSize: "16px", borderRadius: "30px", minWidth: "220px" }}
                  onClick={() => window.location.href = "#about-us"}
                >
                  Download the App
                </Button>
              </div>
            </div>
          </Col>
          <Col
            className="choose-kansensus-image mt-5"
            xs={12}
            md={12}
            lg={{ span: 4, offset: 2 }}
          >
            <img src={Addposter} alt="" />
          </Col>
        </Row>
      </div>
    </>
  );
};
export { Choosekansensus };
